import axios from "axios";

const blogApi = axios.create({
  // baseURL: "https://localhost:7207/api", 
   baseURL: "https://api.merakzy.com/api", 
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token automatically
blogApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("blog_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default blogApi;